export const CHATWOOT_API_TOKEN = 'eQENZd6voK2KzYt3sSfrMnqM';

export const getElements = () => {
    const mainElement = document.querySelector('.woot--bubble-holder');
    const subElement = document.querySelector('.woot-elements--right');
    const btnElement = document.querySelector('.woot--bubble-holder');

    return [mainElement, subElement, btnElement];
};

const isBlockedPage = () => {
    const blockPages = ['waiting', 'online', 'join-interview', 'admin'];
    const isBlocked = blockPages
        .map(page => window.location.pathname.toLowerCase().includes(page))
        .some(value => value === true);
    return isBlocked;
};

const run = () => {
    const BASE_URL = 'https://vocal.cloud';
    if (!window.chatwootSDK) {
        return;
    }
    window.chatwootSDK.run({websiteToken: CHATWOOT_API_TOKEN, baseUrl: BASE_URL});
};
const hideElements = () => {
    getElements().forEach(elem => {
        if (elem) {
            elem.style.display = 'none';
        }
    });
};

const showElements = () => {
    run();
    getElements().forEach(elem => {
        if (elem) {
            elem.style.display = 'block';
        }
    });
};

export const chatWootHelper = {
    show: showElements,
    hide: hideElements,
    isBlocked: isBlockedPage,
    run,
};
